import { makeUseAxios } from "axios-hooks";

import { Config } from "@/utils/config.utils";

import { createApiFor, ExtendedUseAxios } from "./utils";

const storeServiceApi = createApiFor(
    `/storeservice/${Config.general.basestore}`
);

const useStoreServiceApi = makeUseAxios({
    axios: storeServiceApi,
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;

export { useStoreServiceApi };
